/* eslint-disable no-console */
import React, { useMemo, useReducer, useEffect, useState, useRef } from "react";
import NewMenu from "./screens/Menu.js";
import { themes } from "./styles/themes";
import Checkout from "./screens/Checkout.js";
import PromotionScreen from "./screens/Promotion.js";
import Checkin from "./screens/Checkin.js";
import Success from "./screens/Success.js";
import Category from "./screens/Category.js";
import Fail from "./screens/Fail.js";
import Cancel from "./screens/Cancel.js";
import OrderFail from './screens/OrderFail.js';
import PaymentLoading from './screens/PaymentLoading.js';
import CustomerReset from './newcomponents/customerComponents/CustomerReset';
import CustomerLogin from './screens/CustomerLogin.js';
import axios from "axios";
import { Router } from "@reach/router";
import { UserContext, ActionContext, ThemeContext, LanguageContext } from "./contexts/Context";
import { language } from './contexts/languageContext';
import PaymentSummary from './screens/PaymentSummary';
import CustomerDetail from './screens/CustomerDetail.js';
import InitFlow from './screens/InitFlow.js';
import moment from "moment";
import { applyServiceTypePrices } from "./utils/menuPrice";
import { mergeCheckoutPromotions, readPendingContext } from "./utils/pendingOrder";

const MenuWithPromotion = (props) => (
  <>
    <NewMenu {...props} />
    <PromotionScreen />
  </>
);

const CheckoutModalRoute = (props) => (
  <>
    <NewMenu />
    <Checkout {...props} />
  </>
);

const CategoryWithPromotion = (props) => (
  <>
    <Category {...props} />
    <PromotionScreen />
  </>
);

const isEnabled = (value) => value === true || value === "true" || value === 1 || value === "1";

const getTimeOfDayInMinutes = (value) => {
  if (value === null || typeof value === "undefined" || value === "") return null;

  if (typeof value === "string") {
    const timeOnly = value.match(/^(\d{1,2}):(\d{2})(?::\d{2})?$/);
    if (timeOnly) {
      const hour = parseInt(timeOnly[1], 10);
      const minute = parseInt(timeOnly[2], 10);
      return hour < 24 && minute < 60 ? hour * 60 + minute : null;
    }
  }

  const parsedTime = moment(
    typeof value === "string" && /^\d+$/.test(value) ? parseInt(value, 10) : value
  );
  return parsedTime.isValid() ? parsedTime.hour() * 60 + parsedTime.minute() : null;
};

const isWithinServiceChargeExclusionPeriod = (paymentData, currentTime = moment()) => {
  if (!paymentData || !isEnabled(paymentData.excludeSVCWithinPeriod)) return false;

  const startTime = getTimeOfDayInMinutes(paymentData.startTimeSVC);
  const endTime = getTimeOfDayInMinutes(paymentData.endTimeSVC);
  if (startTime === null || endTime === null) return false;

  const checkTime = currentTime.hour() * 60 + currentTime.minute();
  if (startTime <= endTime) {
    return checkTime >= startTime && checkTime <= endTime;
  }

  return checkTime >= startTime || checkTime <= endTime;
};

const applyServiceChargeExclusionPeriod = (paymentData, scheduledTime) => {
  const normalizedScheduledTime = typeof scheduledTime === "string" && /^\d+$/.test(scheduledTime)
    ? parseInt(scheduledTime, 10)
    : scheduledTime;
  const chargeCheckTime = normalizedScheduledTime ? moment(normalizedScheduledTime) : moment();
  if (!chargeCheckTime.isValid() || !isWithinServiceChargeExclusionPeriod(paymentData, chargeCheckTime)) return paymentData;
  return { ...paymentData, serviceCharge: 0 };
};

function App() {
  // State (Reducer)
  // Initial UserState
  const initialUserState = {
    menuList: [],
    // userId: "1df2sssdsf",
    // orderTime: "1619075892765",
    // token: "5e33a1632c937e6a452a1a4f",
    tableLabel: "Loading",

    isTakeAway: false,
    isInRoom: false,
    isMenuView: false,
    takeAwayId: "",
    title: "",
    pax: 0,
    cart: [],
    initCart: [],
    lanIndex: 0,
    ads: [],
    company: { companyName: "-" },
    tax: {},
    menus: [],
    paymentData: {
      excludeSVCWithinPeriod: 0,
      startTimeSVC: 0,
      endTimeSVC: 0
    },
    icons: [],
    skipPaxControl: false,
    skipTAPickUpTime: false,
    allowTAafterWH: true,
    deliveryOrNot: true,
    hasTakeAway: true,
    deliveryCosts: [],
    minimumConsumption: 0,
    checkOutRec: {},
    isForCheckout: false,
    haveToPayOnline: false,
    isOnlinePayMinConsumption: false,
    onlinePayMinConsumptionVal: 0,
    checkboxs: [],
    hasCategoryScreen: false,
    tkType: 0,
    hasAdvocado: false,
    isSearch: false,
    searchTxt: "",
    isSearching: false,
    displayNetAmount: false,
    hasMember: false,
    haveToLogin: false,
    allowRegister: false,
    hasVoucher: false,
    vouchers: [],
    sameDayOrder: false,
    hideLimitedTimeInfo: false,
    displayPaymentTerm: false,
    displayDeliveryTerm: false,
    openingTime: "",
    closingTime: "",
    loginBottomText: "",
    hideOptionalField: false,
    takeAwayInfo: {},
    hasDuration: false,
    duration: 0,
    orderTime: 0,
    initFlowCheck: false,
    hasSlotControl: false,
    pickupTimeInterval: 15,
    isLoad: false,
    isScrollDown: false,
    topCatType: 0,
    displayMenuDescription: false
  };

  //Set to themes[0] in production build
  const [themeContext, setTheme] = useState(themes[0]); // 1,3
  const [languageContext, setLanguage] = useState(language);
  //Memo Actions

  const actionContext = useMemo(
    () => ({
      payByAdvocado: (isAdvocadoPayment) => {
        dispatchUserAction({
          type: "PAY_BY_ADVOCADO",
          isAdvocadoPayment: isAdvocadoPayment
        });
      },
      setSearching: (isSearching) => {
        dispatchUserAction({
          type: "IS_SEARCHING",
          isSearching: isSearching
        });
      },
      setIsSearch: (isSearch) => {
        dispatchUserAction({
          type: "IS_SEARCH",
          isSearch: isSearch,
        });
      },
      setScrollDown: (scrollDown) => {
        dispatchUserAction({
          type: "SCROLL_DOWN",
          isScrollDown: scrollDown
        })
      },
      setSearchTxt: (searchTxt) => {
        dispatchUserAction({
          type: "SET_SEARCHTXT",
          searchTxt: searchTxt,
        });
      },
      setScrolling: (isScrolling) => {
        dispatchUserAction({
          type: "IS_SCROLLING",
          isScrolling: isScrolling,
        });
      },
      addAdCustomer: (adCustomer) => {
        dispatchUserAction({
          type: "ADD_ADCUSTOMER",
          adCustomer: adCustomer
        })
      },

      addTakeAwayInfo: (takeAwayInfo) => {
        localStorage.setItem("takeAwayInfo", JSON.stringify(takeAwayInfo));
        dispatchUserAction({
          type: "ADD_TAKEAWAY_INFO",
          takeAwayInfo: takeAwayInfo
        })
      },
      addCustomer: (customer) => {
        dispatchUserAction({
          type: "ADD_CUSTOMER",
          customer: customer
        })
      },
      addTakeAwayId: (takeAwayId) => {
        dispatchUserAction({
          type: "ADD_TAKEAWAY_ID",
          takeAwayId: takeAwayId,
        });
      },
      setTkType: (tkType) => {
        dispatchUserAction({
          type: "ADD_TAKEAWAY_TYPE",
          tkType: tkType,
        });
      },
      setReserveData: (reserveData) => {
        dispatchUserAction({
          type: "SET_RESERVE_DATA",
          reserveData: reserveData
        })
      },
      setRedeem: (redeem) => {
        dispatchUserAction({
          type: "SET_REDEEM",
          redeem: redeem
        });
      },
      setDiscount: (discount) => {
        dispatchUserAction({
          type: "SET_DISCOUNT",
          discount: discount
        })
      },
      setFinalOrder: (finalOrder) => {
        dispatchUserAction({
          type: "SET_FINAL_ORDER",
          finalOrder: finalOrder,
        });
      },
      addVoucher: (vouchers) => {
        dispatchUserAction({
          type: "ADD_VOUCHER",
          vouchers: vouchers,
        });
      },
      setLoad: (isLoad) => {
        dispatchUserAction({
          type: "MENU_LOAD",
          isLoad: isLoad
        })
      },
      addToCart: (cart) => {
        dispatchUserAction({
          type: "MODIFY_CART",
          cart: cart,
        });
      },
      clearInitCart: () => {
        dispatchUserAction({
          type: "ADD_INIT_CART",
          initCart: []
        });
      },
      clearCart: () => {
        dispatchUserAction({
          type: "MODIFY_CART",
          cart: [],
        });
        dispatchUserAction({
          type: "ADD_VOUCHER",
          cart: [],
        });
      },

      addRecommendation: (recommend) => {
        dispatchUserAction({
          type: "ADD_RECOMMEND",
          recommend: recommend
        })
      },
      addInitCart: (cart) => {
        dispatchUserAction({
          type: "ADD_INIT_CART",
          initCart: cart
        })
      },
      initFlowCheck: (initFlowCheck) => {
        dispatchUserAction({
          type: "INIT_FLOW_CHECK",
          initFlowCheck: initFlowCheck
        })
      },

      removeFromCart: (cart, index) => {
        let handleRemoveIndex = (draft) => {
          return draft;
        };
        let newCart = handleRemoveIndex(cart, index);
        dispatchUserAction({
          type: "MODIFY_CART",
          cart: newCart,
        });
      },
      setMenu: (menuList) => {
        dispatchUserAction({
          type: "SET_MENU",
          menuList: menuList,
          isLoad: true
        });
      },
      setContainerItems: (containerItems) => {
        dispatchUserAction({
          type: "SET_CONTAINER",
          containerItems: containerItems
        });
      },
      addPayType: (payType) => {
        localStorage.setItem("payType", JSON.stringify(payType));
        dispatchUserAction({
          type: "ADD_PAYTYPE",
          payType: payType,
        });
      },
      addPromotion: (pm) => {
        localStorage.setItem("promotion", JSON.stringify(pm));
        dispatchUserAction({
          type: "SET_PROMOTION",
          pm: pm
        })
      },
      registerUserData: (token, userId, orderTime) => {
        if (!token) return;
        localStorage.setItem("token", token);
        localStorage.setItem("userId", userId);
        localStorage.setItem("orderTime", orderTime);

        dispatchUserAction({
          type: "REGISTER_USERDATA",
          userId: userId,
          orderTime: orderTime,
          token: token,
        });
      },
      registerPax: (pax) => {
        localStorage.setItem("pax", pax);

        dispatchUserAction({
          type: "REGISTER_PAX",
          pax: pax,
        });
      },
      registerAds: (ads) => {
        localStorage.setItem("ads", ads);

        dispatchUserAction({
          type: "REGISTER_ADS",
          ads: ads,
        });
      },
      registerMenuTitle: (menus) => {
        dispatchUserAction({
          type: "REGISTER_MENU",
          menus: menus
        })
      },
      registerTableLabel: (tableLabel, isTakeAway, isMenuView, isInRoom, isPreOrder) => {
        localStorage.setItem("tableLabel", isMenuView ? "E Menu" : tableLabel);
        localStorage.setItem("isTakeAway", isTakeAway);
        localStorage.setItem("isMenuView", isMenuView);
        localStorage.setItem("isInRoom", isInRoom);
        localStorage.setItem("isPreOrder", isPreOrder);
        dispatchUserAction({
          type: "REGISTER_TABLE",
          tableLabel: isMenuView ? "E Menu" : tableLabel,
          isTakeAway: isTakeAway,
          isMenuView: isMenuView,
          isInRoom: isInRoom,
          isPreOrder: isPreOrder
        });
      },
      registerCompany: (company) => {
        localStorage.setItem("company", company);

        dispatchUserAction({
          type: "REGISTER_COMPANY",
          company: company,
        });
      },
      registerPaymentData: (paymentData, scheduledTime) => {
        const adjustedPaymentData = applyServiceChargeExclusionPeriod(paymentData, scheduledTime);
        localStorage.setItem("paymentData", JSON.stringify(adjustedPaymentData));

        dispatchUserAction({
          type: "REGISTER_PAYMENTDATA",
          paymentData: adjustedPaymentData,
        });
      },
      registerTax: (tax) => {
        localStorage.setItem("tax", JSON.stringify(tax));

        dispatchUserAction({
          type: "REGISTER_TAX",
          tax: tax,
        });
      },
      registerInitFlow: (hasInitFlow, initFlow) => {
        localStorage.setItem('hasInitFlow', hasInitFlow);
        localStorage.setItem('initFlow', JSON.stringify(initFlow));
        dispatchUserAction({
          type: "REGISTER_INITFLOW",
          hasInitFlow: hasInitFlow,
          initFlow: initFlow
        });
      },
      registerUISetup: (icons, bgImg, landingImg, greetingMessage, tkSuccessMessage, theme, supportMultiLan,
        hasPickUpTime, tkOrderAfter, startTime, endTime, currencySymbol, disSubCatAtSide, skipPaxControl,
        weekDays, allowTAafterWH, deliveryOrNot, deliveryCosts, minimumConsumption, isForCheckout, checkOutRec,
        isOnlinePayMinConsumption, onlinePayMinConsumptionVal, checkboxs,
        addItemDirect, unlimitedScroll, catPos, itemLayout, hasCategoryScreen, hasAdvocado, includeDineIn,
        tkDiMenuDiff, skipCustomerDetail, displayNetAmount, hasTakeAway, hasMember, haveToLogin, successMessage, allowRegister,
        advocadoRedeem, skipDIPickUpTime, skipTAPickUpTime, showLogo, hidePrice, isLanReverse, paymentSelectionMessage, mustDob, payAtCounter, hasVoucher,
        sameDayOrder, hideOptionalField,
        deliveryCalMethod,
        deliveryDisAmt, //if deliveryCalMethod is 1, has discount if more than certain
        deliverySpend, selectPUTimeFirst,
        showKitchenStatus,
        showPickUpInfo,
        pickUpPoint, advocadoStoreCredit, recentBought, memberRedeem,
        showCompanyName, additionalPickUpTime,
        advocadoSignUpLink, allowDineInTakeAway, takeAwayAllowAtCounter, hasFomoPay,
        upsellingTitle, checkStockBeforeCheckOut, mustEmail, smartRec, hasSlotControl, noOfAdvanceDays, hideLimitedTimeInfo, displayPaymentTerm,
        openingTime, closingTime, loginBottomText, topCatType, displayMenuDescription, displayDeliveryTerm, pickupTimeInterval = 15) => {
        displayMenuDescription = isEnabled(displayMenuDescription);
        payAtCounter = isEnabled(payAtCounter);
        localStorage.setItem("icons", icons);
        localStorage.setItem("theme", theme);
        localStorage.setItem("tkSuccessMessage", tkSuccessMessage);
        localStorage.setItem("supportMultiLan", supportMultiLan);
        localStorage.setItem("hasPickUpTime", hasPickUpTime);
        localStorage.setItem("tkOrderAfter", tkOrderAfter);
        localStorage.setItem("startTime", startTime);
        localStorage.setItem("endTime", endTime);
        localStorage.setItem('currencySymbol', currencySymbol);
        localStorage.setItem('disSubCatAtSide', disSubCatAtSide);
        localStorage.setItem('skipPaxControl', skipPaxControl);
        localStorage.setItem('weekDays', JSON.stringify(weekDays));
        localStorage.setItem('allowTAafterWH', allowTAafterWH);
        localStorage.setItem('deliveryOrNot', deliveryOrNot);
        localStorage.setItem('deliveryCosts', JSON.stringify(deliveryCosts));
        localStorage.setItem('minimumConsumption', minimumConsumption);
        localStorage.setItem('isForCheckout', isForCheckout);
        localStorage.setItem('checkOutRec', JSON.stringify(checkOutRec));
        localStorage.setItem('checkboxs', JSON.stringify(checkboxs));
        localStorage.setItem('isOnlinePayMinConsumption', isOnlinePayMinConsumption);
        localStorage.setItem('onlinePayMinConsumptionVal', onlinePayMinConsumptionVal);
        localStorage.setItem('bgImg', bgImg);
        localStorage.setItem('landingImg', landingImg);
        localStorage.setItem('addItemDirect', addItemDirect);
        localStorage.setItem('unlimitedScroll', unlimitedScroll);
        localStorage.setItem('catPos', catPos);
        localStorage.setItem('itemLayout', itemLayout);
        localStorage.setItem('hasCategoryScreen', hasCategoryScreen);
        localStorage.setItem('hasAdvocado', hasAdvocado);
        localStorage.setItem('includeDineIn', includeDineIn);
        localStorage.setItem('tkDiMenuDiff', tkDiMenuDiff);
        localStorage.setItem('skipCustomerDetail', skipCustomerDetail);
        localStorage.setItem('displayNetAmount', displayNetAmount);
        localStorage.setItem('hasTakeAway', hasTakeAway);
        localStorage.setItem('hasMember', hasMember);
        localStorage.setItem('haveToLogin', haveToLogin);
        localStorage.setItem('successMessage', successMessage);
        localStorage.setItem('allowRegister', allowRegister);
        localStorage.setItem("advocadoRedeem", advocadoRedeem);
        localStorage.setItem("skipDIPickUpTime", skipDIPickUpTime);
        localStorage.setItem("skipTAPickUpTime", skipTAPickUpTime);
        localStorage.setItem("showLogo", showLogo);
        localStorage.setItem("hidePrice", hidePrice);
        localStorage.setItem("isLanReverse", isLanReverse);
        localStorage.setItem("paymentSelectionMessage", paymentSelectionMessage);
        localStorage.setItem('mustDob', mustDob);
        localStorage.setItem('mustEmail', mustEmail);
        localStorage.setItem('payAtCounter', payAtCounter);
        localStorage.setItem('hasVoucher', hasVoucher);
        localStorage.setItem('sameDayOrder', sameDayOrder);
        localStorage.setItem('hideOptionalField', hideOptionalField);
        localStorage.setItem('deliveryCalMethod', deliveryCalMethod);
        localStorage.setItem('deliveryDisAmt', deliveryDisAmt);
        localStorage.setItem('deliverySpend', deliverySpend);
        localStorage.setItem('selectPUTimeFirst', selectPUTimeFirst);
        localStorage.setItem('showKitchenStatus', showKitchenStatus);
        localStorage.setItem('showPickUpInfo', showPickUpInfo);
        localStorage.setItem('pickUpPoint', JSON.stringify(pickUpPoint));
        localStorage.setItem('advocadoStoreCredit', advocadoStoreCredit);
        localStorage.setItem('recentBought', recentBought);
        localStorage.setItem('memberRedeem', memberRedeem);
        localStorage.setItem('showCompanyName', showCompanyName);
        localStorage.setItem('additionalPickUpTime', JSON.stringify(additionalPickUpTime));
        localStorage.setItem('advocadoSignUpLink', advocadoSignUpLink);
        localStorage.setItem('allowDineInTakeAway', allowDineInTakeAway);
        localStorage.setItem('takeAwayAllowAtCounter', takeAwayAllowAtCounter);
        localStorage.setItem('hasFomoPay', hasFomoPay);
        localStorage.setItem('upsellingTitle', upsellingTitle);
        localStorage.setItem('checkStockBeforeCheckOut', checkStockBeforeCheckOut);
        localStorage.setItem('smartRec', smartRec);
        localStorage.setItem('hasSlotControl', hasSlotControl);
        localStorage.setItem('pickupTimeInterval', pickupTimeInterval);
        localStorage.setItem('noOfAdvanceDays', noOfAdvanceDays);
        localStorage.setItem('hideLimitedTimeInfo', hideLimitedTimeInfo);
        localStorage.setItem('displayPaymentTerm', displayPaymentTerm);
        localStorage.setItem('displayDeliveryTerm', displayDeliveryTerm);
        localStorage.setItem('openingTime', openingTime || "");
        localStorage.setItem('closingTime', closingTime || "");
        localStorage.setItem('loginBottomText', loginBottomText || "");
        localStorage.setItem('topCatType', topCatType)
        localStorage.setItem('displayMenuDescription', displayMenuDescription);
        if (isLanReverse) {
          dispatchUserAction({
            type: "REGISTER_LANINDEX",
            lanIndex: 1
          });
        }
        dispatchUserAction({
          type: "REGISTER_ICONS",
          icons: icons,
        });
        dispatchUserAction({
          type: "REGISTER_BACKGROUNDIMAGE",
          bgImg: bgImg,
          landingImg: landingImg,
          supportMultiLan,
          hasPickUpTime,
          tkOrderAfter,
          startTime,
          endTime,
          currencySymbol,
          disSubCatAtSide,
          skipPaxControl,
          weekDays,
          allowTAafterWH,
          deliveryOrNot,
          deliveryCosts,
          minimumConsumption,
          isForCheckout,
          checkOutRec,
          isOnlinePayMinConsumption,
          onlinePayMinConsumptionVal,
          checkboxs,
          addItemDirect,
          unlimitedScroll,
          catPos,
          itemLayout,
          hasCategoryScreen,
          hasAdvocado,
          includeDineIn,
          tkDiMenuDiff,
          skipCustomerDetail,
          displayNetAmount,
          hasTakeAway,
          hasMember,
          haveToLogin,
          successMessage,
          allowRegister,
          advocadoRedeem,
          skipDIPickUpTime,
          skipTAPickUpTime,
          showLogo,
          hidePrice,
          isLanReverse,
          paymentSelectionMessage,
          mustDob,
          payAtCounter,
          hasVoucher,
          sameDayOrder,
          hideOptionalField,
          deliveryCalMethod,
          deliveryDisAmt, //if deliveryCalMethod is 1, has discount if more than certain
          deliverySpend,
          selectPUTimeFirst,
          showKitchenStatus,
          showPickUpInfo,
          pickUpPoint,
          advocadoStoreCredit,
          recentBought,
          memberRedeem,
          showCompanyName,
          additionalPickUpTime,
          advocadoSignUpLink,
          allowDineInTakeAway,
          takeAwayAllowAtCounter,
          hasFomoPay,
          upsellingTitle,
          checkStockBeforeCheckOut,
          isLoad: true,
          mustEmail,
          smartRec,
          hasSlotControl,
          pickupTimeInterval,
          noOfAdvanceDays,
          hideLimitedTimeInfo,
          displayPaymentTerm,
          openingTime,
          closingTime,
          loginBottomText,
          topCatType,
          displayMenuDescription,
          displayDeliveryTerm
        });
        dispatchUserAction({
          type: "REGISTER_GREETINGMESSAGE",
          greetingMessage: greetingMessage,
          tkSuccessMessage: tkSuccessMessage,
          successMessage: successMessage
        });
        dispatchUserAction({
          type: "REGISTER_THEME",
          theme: theme
        });

      },
      registerOtherUrl: (otherUrls) => {
        localStorage.setItem("otherUrl", otherUrls);
        dispatchUserAction({
          type: "REGISTER_OTHERURLS",
          otherUrls: otherUrls,
        });
      },

      registerAsiaPay: (asiaPay, hasPayment, paymentPlatform, PaymentTakeawayOnly, isDemo, haveToPayOnline) => {
        localStorage.setItem("asiaPay", asiaPay);
        localStorage.setItem("hasPayment", hasPayment);
        localStorage.setItem("paymentPlatform", paymentPlatform);
        localStorage.setItem("PaymentTakeawayOnly", PaymentTakeawayOnly);
        localStorage.setItem('haveToPayOnline', haveToPayOnline);
        dispatchUserAction({
          type: "REGISTER_ASIAPAY",
          asiaPay: asiaPay,
          hasPayment: hasPayment,
          PaymentTakeawayOnly: PaymentTakeawayOnly,
          paymentPlatform: paymentPlatform,
          isDemo: isDemo,
          haveToPayOnline
        });
      },
      updateTitle: (title) => {
        localStorage.setItem("TITLE", title);
        dispatchUserAction({
          type: "UPDATE_TITLE",
          title: title
        })
      },
      updateDuration: (data) => {
        dispatchUserAction({
          type: "UPDATE_DURATION",
          duration: data.duration,
          hasDuration: data.hasDuration,
          orderTime: data.orderTime
        })
      },
      setLanIndex: (lanIndex) => {
        localStorage.setItem("lanIndex", lanIndex);
        dispatchUserAction({
          type: "REGISTER_LANINDEX",
          lanIndex: lanIndex
        });
      },
      setRecentItem: (recentItem) => {
        dispatchUserAction({
          type: "SET_RECENT_ITEM",
          recentItem: recentItem
        });
      },
    }),
    []
  );

  //User Reducer
  const userReducer = (prevState, action) => {
    switch (action.type) {
      case "IS_SEARCH":
        return {
          ...prevState,
          isSearch: action.isSearch
        }
      case "SCROLL_DOWN":
        return {
          ...prevState,
          isScrollDown: action.isScrollDown
        }
      case "IS_SEARCHING":
        return {
          ...prevState,
          isSearching: action.isSearching
        }
      case "SET_SEARCHTXT":
        return {
          ...prevState,
          searchTxt: action.searchTxt
        }
      case "IS_SCROLLING":
        return {
          ...prevState,
          isScrolling: action.isScrolling
        };
      case "ADD_ADCUSTOMER":
        return {
          ...prevState,
          adCustomer: action.adCustomer
        }
      case "ADD_TAKEAWAY_INFO":
        return {
          ...prevState,
          takeAwayInfo: action.takeAwayInfo
        }
      case "ADD_CUSTOMER":
        return {
          ...prevState,
          customer: action.customer
        }
      case "PAY_BY_ADVOCADO":
        return {
          ...prevState,
          isAdvocadoPayment: action.isAdvocadoPayment
        }
      case "ADD_TAKEAWAY_ID":
        return {
          ...prevState,
          takeAwayId: action.takeAwayId
        };
      case "ADD_TAKEAWAY_TYPE":
        return {
          ...prevState,
          tkType: action.tkType,
          menuList: isEnabled(prevState.company && prevState.company.hasCombineMenu)
            ? applyServiceTypePrices(prevState.menuList, action.tkType)
            : prevState.menuList
        }
      case "SET_RESERVE_DATA":
        return {
          ...prevState,
          reserveData: action.reserveData
        }
      case "ADD_INIT_CART":
        return {
          ...prevState,
          initCart: action.initCart
        }
      case "INIT_FLOW_CHECK":
        return {
          ...prevState,
          initFlowCheck: action.initFlowCheck
        }
      case "MODIFY_CART":
        return {
          ...prevState,
          cart: action.cart,
        };
      case "MENU_LOAD":
        return {
          ...prevState,
          isLoad: action.isLoad
        }
      case "ADD_VOUCHER":
        return {
          ...prevState,
          vouchers: action.vouchers
        }
      case "SET_FINAL_ORDER":
        return {
          ...prevState,
          finalOrder: action.finalOrder
        }
      case "SET_REDEEM":
        return {
          ...prevState,
          redeem: action.redeem
        }
      case "SET_DISCOUNT":
        return {
          ...prevState,
          discount: action.discount
        }
      case "ADD_RECOMMEND":
        return {
          ...prevState,
          recommend: action.recommend,
        };
      case "SET_MENU":
        return {
          ...prevState,
          menuList: action.menuList,
          isLoad: action.isLoad
        };
      case "SET_CONTAINER":
        return {
          ...prevState,
          containerItems: action.containerItems
        }
      case "REGISTER_USERDATA":
        return {
          ...prevState,
          userId: action.userId,
          orderTime: action.orderTime,
          token: action.token,
        };
      case "REGISTER_PAX":
        return {
          ...prevState,
          pax: action.pax,
        };

      case "REGISTER_ADS":
        return {
          ...prevState,
          ads: action.ads,
        };

      case "REGISTER_COMPANY":
        return {
          ...prevState,
          company: action.company
        };

      case "REGISTER_TABLE":
        return {
          ...prevState,
          tableLabel: action.tableLabel,
          isTakeAway: action.isTakeAway,
          isMenuView: action.isMenuView,
          isInRoom: action.isInRoom,
          isPreOrder: action.isPreOrder
        };
      case "REGISTER_PAYMENTDATA":
        return {
          ...prevState,
          paymentData: action.paymentData,
        };
      case "REGISTER_TAX":
        return {
          ...prevState,
          tax: action.tax,
        };
      case "ADD_PAYTYPE":
        return {
          ...prevState,
          payType: action.payType
        };
      case "REFRESH_PROMOTION":
        return { ...prevState, pm: mergeCheckoutPromotions(action.pm, prevState) };
      case "SET_PROMOTION":
        return {
          ...prevState,
          pm: action.pm
        };
      case "REGISTER_ICONS":
        return {
          ...prevState,
          icons: action.icons,
        };
      case "REGISTER_INITFLOW":
        return {
          ...prevState,
          hasInitFlow: action.hasInitFlow,
          initFlow: action.initFlow
        };
      case "REGISTER_BACKGROUNDIMAGE":
        return {
          ...prevState,
          bgImg: action.bgImg,
          landingImg: action.landingImg,
          supportMultiLan: action.supportMultiLan,
          hasPickUpTime: action.hasPickUpTime,
          tkOrderAfter: action.tkOrderAfter,
          startTime: action.startTime,
          endTime: action.endTime,
          currencySymbol: action.currencySymbol,
          disSubCatAtSide: action.disSubCatAtSide,
          skipPaxControl: action.skipPaxControl,
          weekDays: action.weekDays,
          allowTAafterWH: action.allowTAafterWH,
          deliveryOrNot: action.deliveryOrNot,
          deliveryCosts: action.deliveryCosts,
          minimumConsumption: action.minimumConsumption,
          isForCheckout: action.isForCheckout,
          checkOutRec: action.checkOutRec,
          isOnlinePayMinConsumption: action.isOnlinePayMinConsumption,
          onlinePayMinConsumptionVal: action.onlinePayMinConsumptionVal,
          checkboxs: action.checkboxs,
          addItemDirect: action.addItemDirect,
          unlimitedScroll: action.unlimitedScroll,
          catPos: action.catPos,
          itemLayout: action.itemLayout,
          hasCategoryScreen: action.hasCategoryScreen,
          hasAdvocado: action.hasAdvocado,
          includeDineIn: action.includeDineIn,
          tkDiMenuDiff: action.tkDiMenuDiff,
          skipCustomerDetail: action.skipCustomerDetail,
          displayNetAmount: action.displayNetAmount,
          hasTakeAway: action.hasTakeAway,
          hasMember: action.hasMember,
          haveToLogin: action.haveToLogin,
          successMessage: action.successMessage,
          allowRegister: action.allowRegister,
          advocadoRedeem: action.advocadoRedeem,
          skipDIPickUpTime: action.skipDIPickUpTime,
          skipTAPickUpTime: action.skipTAPickUpTime,
          showLogo: action.showLogo,
          hidePrice: action.hidePrice,
          isLanReverse: action.isLanReverse,
          paymentSelectionMessage: action.paymentSelectionMessage,
          mustDob: action.mustDob,
          payAtCounter: action.payAtCounter,
          hasVoucher: action.hasVoucher,
          sameDayOrder: action.sameDayOrder,
          hideOptionalField: action.hideOptionalField,
          deliveryCalMethod: action.deliveryCalMethod,
          deliveryDisAmt: action.deliveryDisAmt, //if deliveryCalMethod is 1, has discount if more than certain
          deliverySpend: action.deliverySpend,
          selectPUTimeFirst: action.selectPUTimeFirst,
          showKitchenStatus: action.showKitchenStatus,
          showPickUpInfo: action.showPickUpInfo,
          pickUpPoint: action.pickUpPoint,
          advocadoStoreCredit: action.advocadoStoreCredit,
          recentBought: action.recentBought,
          memberRedeem: action.memberRedeem,
          showCompanyName: action.showCompanyName,
          additionalPickUpTime: action.additionalPickUpTime,
          advocadoSignUpLink: action.advocadoSignUpLink,
          allowDineInTakeAway: action.allowDineInTakeAway,
          takeAwayAllowAtCounter: action.takeAwayAllowAtCounter,
          hasFomoPay: action.hasFomoPay,
          upsellingTitle: action.upsellingTitle,
          checkStockBeforeCheckOut: action.checkStockBeforeCheckOut,
          mustEmail: action.mustEmail,
          smartRec: action.smartRec,
          hasSlotControl: action.hasSlotControl,
          pickupTimeInterval: action.pickupTimeInterval,
          noOfAdvanceDays: action.noOfAdvanceDays,
          hideLimitedTimeInfo: action.hideLimitedTimeInfo,
          displayPaymentTerm: action.displayPaymentTerm,
          openingTime: action.openingTime,
          closingTime: action.closingTime,
          loginBottomText: action.loginBottomText,
          topCatType: action.topCatType,
          displayMenuDescription: action.displayMenuDescription,
          displayDeliveryTerm: action.displayDeliveryTerm
        };
      case "REGISTER_GREETINGMESSAGE":
        return {
          ...prevState,
          greetingMessage: action.greetingMessage,
          tkSuccessMessage: action.tkSuccessMessage,
          successMessage: action.successMessage
        };
      case "REGISTER_THEME":
        return {
          ...prevState,
          theme: action.theme
        }
      case "REGISTER_ASIAPAY":
        return {
          ...prevState,
          hasPayment: action.hasPayment,
          asiaPay: action.asiaPay,
          paymentPlatform: action.paymentPlatform,
          PaymentTakeawayOnly: action.PaymentTakeawayOnly,
          isDemo: action.isDemo,
          haveToPayOnline: action.haveToPayOnline
        };
      case "REGISTER_OTHERURLS":
        return {
          ...prevState,
          otherUrls: action.otherUrls,
        };
      case "REGISTER_MENU":
        return {
          ...prevState,
          menus: action.menus
        };
      case "UPDATE_TITLE":
        return {
          ...prevState,
          title: action.title
        }
      case "UPDATE_DURATION":
        return {
          ...prevState,
          duration: action.duration,
          hasDuration: action.hasDuration,
          orderTime: action.orderTime
        }
      case "REGISTER_LANINDEX":
        return {
          ...prevState,
          lanIndex: action.lanIndex
        }
      case "SET_RECENT_ITEM":
        return {
          ...prevState,
          recentItem: action.recentItem
        }
    }
  };
  //useReducer Init
  const [userState, dispatchUserAction] = useReducer(
    userReducer,
    initialUserState
  );
  const latestUserState = useRef(userState);
  latestUserState.current = userState;
  useEffect(() => {
    if (userState.pm !== undefined) localStorage.setItem('promotion', JSON.stringify(userState.pm));
  }, [userState.pm]);

  // Restore cached app state once on startup.
  useEffect(() => {
    let token = "";
    let isDemo = false;
    let userId = "";
    let orderTime = "";
    let pax = -1;
    let icons = ["/Promo1.png", "/Promo2.png", "/Promo3.png"];
    let bgImg = "";
    let landingImg = "";
    let title = "";
    let currencySymbol = "SGD";
    let paymentPlatform = 0;
    let hasPayment = true;
    let PaymentTakeawayOnly = false;
    let asiaPay = {};
    let theme = 0;
    let greetingMessage = `Welcome!\nPlease only order one at a time!`;
    let tkSuccessMessage = "";
    let successMessage = "";
    let disSubCatAtSide = true;
    let allowTAafterWH = true;
    let deliveryOrNot = false;
    let hasTakeAway = true;
    let deliveryCosts = [];
    let minimumConsumption = 0;
    let checkOutRec = {};
    let checkboxs = [];
    let isOnlinePayMinConsumption = false;
    let onlinePayMinConsumptionVal = 0;
    let isForCheckout = false;
    let addItemDirect = true;
    let unlimitedScroll = true;
    let catPos = 1;
    let itemLayout = 0;
    let displayMenuDescription = true;
    let hasCategoryScreen = false;
    let hasAdvocado = false;
    let includeDineIn = true;
    let tkDiMenuDiff = false;
    let hasMember = true;
    let haveToLogin = false;
    let allowRegister = false;
    //comment out to test
    bgImg = localStorage.getItem('bgImg') != null ? localStorage.getItem('bgImg') : "";
    landingImg = localStorage.getItem('landingImg');
    pax = localStorage.getItem("pax");
    token = localStorage.getItem("token");
    isDemo = localStorage.getItem("isDemo");
    userId = localStorage.getItem("userId");
    orderTime = localStorage.getItem("orderTime");
    title = localStorage.getItem("TITLE") != null ? localStorage.getItem("TITLE") : title;
    asiaPay = localStorage.getItem("asiaPay", asiaPay);
    hasPayment = localStorage.getItem("hasPayment", hasPayment) != null ? localStorage.getItem("hasPayment", hasPayment) : hasPayment;
    PaymentTakeawayOnly = localStorage.getItem("PaymentTakeawayOnly") != null ? localStorage.getItem("PaymentTakeawayOnly") : PaymentTakeawayOnly;
    paymentPlatform = localStorage.getItem("paymentPlatform", paymentPlatform);
    tkSuccessMessage = localStorage.getItem('tkSuccessMessage');
    successMessage = localStorage.getItem('successMessage');
    theme = localStorage.getItem('theme') != null ? localStorage.getItem("theme") : 1;
    currencySymbol = localStorage.getItem('currencySymbol') != null ? localStorage.getItem('currencySymbol') : "SGD";
    disSubCatAtSide = localStorage.getItem("disSubCatAtSide") != null ? localStorage.getItem("disSubCatAtSide") : disSubCatAtSide;
    allowTAafterWH = localStorage.getItem('allowTAafterWH') != null ? localStorage.getItem('allowTAafterWH') : allowTAafterWH;
    //dummy data
    deliveryOrNot = localStorage.getItem("deliveryOrNot") != null ? localStorage.getItem("deliveryOrNot") : deliveryOrNot;
    hasTakeAway = localStorage.getItem('hasTakeAway') != null ? localStorage.getItem('hasTakeAway') : hasTakeAway;
    hasMember = localStorage.getItem('hasMember') != null ? localStorage.getItem('hasMember') : hasMember;
    haveToLogin = localStorage.getItem('haveToLogin') != null ? localStorage.getItem('haveToLogin') : haveToLogin;
    allowRegister = localStorage.getItem('allowRegister') != null ? localStorage.getItem('allowRegister') : allowRegister;
    deliveryCosts = localStorage.getItem("deliveryCosts");
    addItemDirect = localStorage.getItem("addItemDirect") != null ? localStorage.getItem("addItemDirect") : addItemDirect;
    minimumConsumption = localStorage.getItem("minimumConsumption");
    checkOutRec = localStorage.getItem("checkOutRec");
    hasCategoryScreen = localStorage.getItem("hasCategoryScreen") != null ? localStorage.getItem("hasCategoryScreen") : hasCategoryScreen;
    hasAdvocado = localStorage.getItem("hasAdvocado") != null ? localStorage.getItem("hasAdvocado") : hasAdvocado;
    includeDineIn = localStorage.getItem("includeDineIn") != null ? localStorage.getItem("includeDineIn") : includeDineIn;
    tkDiMenuDiff = localStorage.getItem("tkDiMenuDiff") != null ? localStorage.getItem("tkDiMenuDiff") : tkDiMenuDiff;
    let skipCustomerDetail = localStorage.getItem("skipCustomerDetail") != null ? localStorage.getItem("skipCustomerDetail") : false;

    if (checkOutRec && checkOutRec != 'undefined' && checkOutRec != null) {
      checkOutRec = JSON.parse(checkOutRec);
    } else {
      checkOutRec = {};
    }
    isForCheckout = localStorage.getItem("isForCheckout");
    //new enhancement
    let supportMultiLan = localStorage.getItem("supportMultiLan") != null ? localStorage.getItem("supportMultiLan") : true;
    let hasPickUpTime = localStorage.getItem("hasPickUpTime");
    let tkOrderAfter = localStorage.getItem("tkOrderAfter");
    let startTime = localStorage.getItem("startTime") ? localStorage.getItem("startTime") : 0;
    let endTime = localStorage.getItem("endTime") ? localStorage.getItem("endTime") : 0;
    let skipPaxControl = localStorage.getItem("skipPaxControl") != null ? localStorage.getItem("skipPaxControl") : false;
    let displayNetAmount = localStorage.getItem("displayNetAmount") != null ? localStorage.getItem("displayNetAmount") : false;
    let weekDays = localStorage.getItem("weekDays") != null ? localStorage.getItem("weekDays") : "";
    let mustDob = localStorage.getItem('mustDob') != null ? localStorage.getItem('mustDob') : false;
    let mustEmail = localStorage.getItem('mustEmail') != null ? localStorage.getItem('mustEmail') : false;
    let smartRec = localStorage.getItem('smartRec') != null ? localStorage.getItem('smartRec') : false;
    const pickupTimeInterval = localStorage.getItem('pickupTimeInterval') || 15;
    let hasSlotControl = localStorage.getItem('hasSlotControl') != null ? localStorage.getItem('hasSlotControl') : false;
    let payAtCounter = isEnabled(localStorage.getItem('payAtCounter'));
    let hasVoucher = localStorage.getItem('hasVoucher') != null ? localStorage.getItem('hasVoucher') : true;
    checkboxs = localStorage.getItem("checkboxs");
    isOnlinePayMinConsumption = localStorage.getItem("isOnlinePayMinConsumption") != null ? localStorage.getItem("isOnlinePayMinConsumption") : isOnlinePayMinConsumption;
    onlinePayMinConsumptionVal = localStorage.getItem("onlinePayMinConsumptionVal") != null ? localStorage.getItem("onlinePayMinConsumptionVal") : onlinePayMinConsumptionVal;
    let sameDayOrder = localStorage.getItem("sameDayOrder") != null ? localStorage.getItem('sameDayOrder') : false;
    let pm = localStorage.getItem("promotion") != null ? localStorage.getItem("promotion") : [];
    let hideOptionalField = localStorage.getItem("hideOptionalField") != null ? localStorage.getItem("hideOptionalField") : false;
    if (pm && typeof pm != 'undefined' && pm != null) {
      // pm = JSON.parse(pm);
      pm = [];
    } else {
      pm = [];
    }

    if (weekDays && weekDays != 'undefined' && weekDays != null) {
      weekDays = JSON.parse(weekDays);
    } else {
      weekDays = [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday"
      ];
    }
    if (deliveryCosts && deliveryCosts != 'undefined' && deliveryCosts != null) {
      deliveryCosts = JSON.parse(deliveryCosts);
    } else {
      deliveryCosts = [];
    }
    if (checkboxs && checkboxs != 'undefined' && checkboxs != null) {
      checkboxs = JSON.parse(checkboxs);
    } else {
      checkboxs = [];
    }
    let haveToPayOnline = localStorage.getItem('haveToPayOnline') != null ? localStorage.getItem('haveToPayOnline') : false;
    let isTakeAway = localStorage.getItem("isTakeAway") != null ? localStorage.getItem("isTakeAway") : false;
    let isPreOrder = localStorage.getItem("isPreOrder") != null ? localStorage.getItem("isPreOrder") : false;
    let tableLabel = localStorage.getItem("tableLabel") != null ? localStorage.getItem("tableLabel") : "";
    let isMenuView = localStorage.getItem("isMenuView");
    unlimitedScroll = localStorage.getItem("unlimitedScroll") != null ? localStorage.getItem("unlimitedScroll") : unlimitedScroll;
    let advocadoRedeem = localStorage.getItem("advocadoRedeem") != null ? localStorage.getItem("advocadoRedeem") : false;
    let skipDIPickUpTime = localStorage.getItem("skipDIPickUpTime") != null ? localStorage.getItem("skipDIPickUpTime") : false;
    let skipTAPickUpTime = localStorage.getItem("skipTAPickUpTime") != null ? localStorage.getItem("skipTAPickUpTime") : false;
    catPos = localStorage.getItem("catPos") != null ? localStorage.getItem("catPos") : catPos;
    itemLayout = localStorage.getItem("itemLayout") != null ? localStorage.getItem("itemLayout") : itemLayout;
    displayMenuDescription = localStorage.getItem("displayMenuDescription") != null ? localStorage.getItem("displayMenuDescription") : displayMenuDescription;
    let company = { _id: "test", companyName: "-", companyLogo: "", hasCombineMenu: true };
    let showLogo = localStorage.getItem('showLogo') != null ? localStorage.getItem('showLogo') : false;
    let hidePrice = localStorage.getItem('hidePrice') != null ? localStorage.getItem('hidePrice') : false;
    let isLanReverse = localStorage.getItem('isLanReverse') != null ? localStorage.getItem('isLanReverse') : false;
    let vouchers = sessionStorage.getItem('vouchers') != null ? sessionStorage.getItem('vouchers') : '';
    let deliveryCalMethod = localStorage.getItem('deliveryCalMethod') != null ? localStorage.getItem('deliveryCalMethod') : 0;
    let deliveryDisAmt = localStorage.getItem('deliveryDisAmt') != null ? localStorage.getItem('deliveryDisAmt') : 0; //if deliveryCalMethod is 1, has discount if more than certain
    let deliverySpend = localStorage.getItem('deliverySpend') != null ? localStorage.getItem('deliverySpend') : 0;
    let selectPUTimeFirst = localStorage.getItem('selectPUTimeFirst') != null ? localStorage.getItem('selectPUTimeFirst') : true;
    if (vouchers) {
      vouchers = JSON.parse(vouchers);
    } else {
      vouchers = [];
    }

    let showKitchenStatus = localStorage.getItem('showKitchenStatus') != null ? localStorage.getItem('showKitchenStatus') : false;
    let showPickUpInfo = localStorage.getItem('showPickUpInfo') != null ? localStorage.getItem('showPickUpInfo') : false;
    let pickUpPoint = localStorage.getItem('pickUpPoint') != null ? localStorage.getItem('pickUpPoint') : '';
    if (pickUpPoint && typeof pickUpPoint != 'undefined' && pickUpPoint != null && pickUpPoint != 'undefined') {
      pickUpPoint = JSON.parse(pickUpPoint);
    } else {
      pickUpPoint = [];
    }
    let advocadoStoreCredit = localStorage.getItem('advocadoStoreCredit') != null ? localStorage.getItem('advocadoStoreCredit') : false;
    let recentBought = localStorage.getItem('recentBought') != null ? localStorage.getItem('recentBought') : false;
    let memberRedeem = localStorage.getItem('memberRedeem') != null ? localStorage.getItem('memberRedeem') : false;
    let showCompanyName = localStorage.getItem('showCompanyName') != null ? localStorage.getItem('showCompanyName') : false;
    let paymentSelectionMessage = localStorage.getItem("paymentSelectionMessage") != null ? localStorage.getItem("paymentSelectionMessage") : ""
    let additionalPickUpTime = localStorage.getItem('additionalPickUpTime') != null ? localStorage.getItem('additionalPickUpTime') : [];
    let advocadoSignUpLink = localStorage.getItem('advocadoSignUpLink') != null ? localStorage.getItem('advocadoSignUpLink') : '';
    let allowDineInTakeAway = localStorage.getItem('allowDineInTakeAway') != null ? localStorage.getItem('allowDineInTakeAway') : true;
    let takeAwayAllowAtCounter = localStorage.getItem('takeAwayAllowAtCounter') != null ? localStorage.getItem('takeAwayAllowAtCounter') : false;
    let hasFomoPay = localStorage.getItem("hasFomoPay") != null ? localStorage.getItem("hasFomoPay") : false;
    let upsellingTitle = localStorage.getItem('upsellingTitle') != null ? localStorage.getItem('upsellingTitle') : "";
    let checkStockBeforeCheckOut = localStorage.getItem('checkStockBeforeSelling') != null ? localStorage.getItem('checkStockBeforeCheckOut') : false;
    let noOfAdvanceDays = localStorage.getItem("noOfAdvanceDays") != null ? localStorage.getItem("noOfAdvanceDays") : 30;
    let hideLimitedTimeInfo = localStorage.getItem('hideLimitedTimeInfo') != null ? localStorage.getItem('hideLimitedTimeInfo') : false;
    let displayPaymentTerm = localStorage.getItem('displayPaymentTerm') != null ? localStorage.getItem('displayPaymentTerm') : false;
    let displayDeliveryTerm = localStorage.getItem('displayDeliveryTerm') != null ? localStorage.getItem('displayDeliveryTerm') : false;
    let openingTime = localStorage.getItem('openingTime') != null ? localStorage.getItem('openingTime') : "";
    let closingTime = localStorage.getItem('closingTime') != null ? localStorage.getItem('closingTime') : "";
    let loginBottomText = localStorage.getItem('loginBottomText') != null ? localStorage.getItem('loginBottomText') : "";
    let topCatType = localStorage.getItem('topCatType') != null ? localStorage.getItem('topCatType') : 0;
    let adCustomer = localStorage.getItem("adCustomer");
    if (adCustomer && adCustomer != null) {
      adCustomer = JSON.parse(adCustomer);
    }
    const pendingContext = readPendingContext();
    let takeAwayInfo = pendingContext && pendingContext.takeAwayInfo
      ? JSON.stringify(pendingContext.takeAwayInfo)
      : localStorage.getItem("takeAwayInfo");
    if (isTakeAway && takeAwayInfo && typeof takeAwayInfo != 'undefined' && takeAwayInfo != null && takeAwayInfo != 'undefined') {
      if (pendingContext || new Date().getTime() - JSON.parse(takeAwayInfo).saveTime < 15 * 60000) {
        dispatchUserAction({ type: "ADD_TAKEAWAY_INFO", takeAwayInfo: JSON.parse(takeAwayInfo) });
        dispatchUserAction({ type: "ADD_TAKEAWAY_TYPE", tkType: JSON.parse(takeAwayInfo).deliveryType });
      }
    }
    let initFlow = localStorage.getItem("initFlow");
    if (initFlow && typeof initFlow != 'undefined' && initFlow != null && initFlow != 'undefined') {
      initFlow = JSON.parse(initFlow);
    } else {
      initFlow = [];
    }
    let hasInitFlow = localStorage.getItem("hasInitFlow") != null ? localStorage.getItem("hasInitFlow") : false;


    let customer = localStorage.getItem("customer");
    if (customer && customer != null) {
      customer = JSON.parse(customer);
    }

    let lanIndex = 0;
    supportMultiLan = supportMultiLan != null && supportMultiLan ? supportMultiLan : true;

    dispatchUserAction({
      type: "ADD_ADCUSTOMER",
      adCustomer: adCustomer
    });

    dispatchUserAction({
      type: "ADD_CUSTOMER",
      customer: customer
    });

    dispatchUserAction({
      type: "REGISTER_COMPANY",
      company: company,
    });

    dispatchUserAction({
      type: "REGISTER_ICONS",
      icons: icons,
    });

    dispatchUserAction({
      type: "SET_PROMOTION",
      pm: pm
    });

    dispatchUserAction({
      type: "REGISTER_INITFLOW",
      hasInitFlow: hasInitFlow,
      initFlow: initFlow,
    });

    dispatchUserAction({
      type: "REGISTER_BACKGROUNDIMAGE",
      bgImg: bgImg,
      landingImg: landingImg,
      supportMultiLan,
      hasPickUpTime,
      tkOrderAfter,
      startTime,
      endTime,
      currencySymbol,
      disSubCatAtSide,
      skipPaxControl,
      weekDays,
      allowTAafterWH,
      deliveryOrNot,
      deliveryCosts,
      minimumConsumption,
      isForCheckout,
      checkOutRec,
      isOnlinePayMinConsumption,
      onlinePayMinConsumptionVal,
      checkboxs,
      addItemDirect,
      unlimitedScroll,
      catPos,
      itemLayout,
      hasCategoryScreen,
      hasAdvocado,
      includeDineIn,
      tkDiMenuDiff,
      skipCustomerDetail,
      displayNetAmount,
      hasTakeAway,
      hasMember,
      haveToLogin,
      successMessage,
      allowRegister,
      advocadoRedeem,
      skipDIPickUpTime,
      skipTAPickUpTime,
      showLogo,
      hidePrice,
      isLanReverse,
      paymentSelectionMessage,
      mustDob,
      payAtCounter,
      hasVoucher,
      sameDayOrder,
      hideOptionalField,
      deliveryCalMethod,
      deliveryDisAmt,
      deliverySpend,
      selectPUTimeFirst,
      showKitchenStatus,
      showPickUpInfo,
      pickUpPoint,
      advocadoStoreCredit,
      recentBought,
      memberRedeem,
      showCompanyName,
      additionalPickUpTime,
      advocadoSignUpLink,
      allowDineInTakeAway,
      takeAwayAllowAtCounter,
      hasFomoPay,
      upsellingTitle,
      checkStockBeforeCheckOut,
      mustEmail,
      smartRec,
      hasSlotControl,
      pickupTimeInterval,
      isLoad: true,
      noOfAdvanceDays,
      hideLimitedTimeInfo,
      displayPaymentTerm,
      displayDeliveryTerm,
      openingTime,
      closingTime,
      loginBottomText,
      topCatType,
      displayMenuDescription
    });

    dispatchUserAction({
      type: "REGISTER_GREETINGMESSAGE",
      greetingMessage: greetingMessage,
      tkSuccessMessage: tkSuccessMessage,
      successMessage: successMessage
    });

    dispatchUserAction({
      type: "REGISTER_PAX",
      pax: pax,
    });

    dispatchUserAction({
      type: "REGISTER_USERDATA",
      userId: userId,
      orderTime: orderTime,
      token: token
    });

    dispatchUserAction({
      type: "UPDATE_TITLE",
      title: title
    });

    dispatchUserAction({
      type: "REGISTER_ASIAPAY",
      asiaPay: asiaPay,
      hasPayment: hasPayment,
      PaymentTakeawayOnly: PaymentTakeawayOnly,
      paymentPlatform: paymentPlatform,
      isDemo: isDemo,
      haveToPayOnline: haveToPayOnline,
    });

    dispatchUserAction({
      type: "REGISTER_THEME",
      theme: theme
    });

    dispatchUserAction({
      type: "REGISTER_LANINDEX",
      lanIndex: lanIndex
    });
    dispatchUserAction({
      type: "REGISTER_TABLE",
      tableLabel: tableLabel,
      isTakeAway: isTakeAway,
      isMenuView: isMenuView,
      isPreOrder: isPreOrder
    });
    dispatchUserAction({
      type: "IS_SCROLLING",
      isScrolling: false
    });
    //clear recommend first
    dispatchUserAction({
      type: "ADD_RECOMMEND",
      recommend: []
    });
    dispatchUserAction({
      type: "ADD_VOUCHER",
      vouchers: vouchers
    })
  }, []);

  // Refresh general data when order identity or scheduled time changes.
  useEffect(() => {
    let active = true;
    if (userState.userId) {
      const scheduleTime = userState.takeAwayInfo && userState.takeAwayInfo.scheduleTime ? userState.takeAwayInfo.scheduleTime : 0;
      axios.get(
        `/v2/api/selforder/general?userId=${userState.userId}&orderTime=${userState.orderTime}&scheduleTime=${scheduleTime}`,
        {
          headers: {
            Authorization: "Bearer " + userState.token,
          },
        }
      )
        .then(function (response) {
          if (!active) return;
          // handle success
          actionContext.setMenu(response.data.stockItems);
          actionContext.registerAds(response.data.ads);
          actionContext.registerCompany(response.data.company);
          actionContext.registerTableLabel(response.data.tableLabel, response.data.isTakeAway, response.data.isMenuView, response.data.isInRoom, response.data.isPreOrder);
          actionContext.registerTax(response.data.tax);
          actionContext.registerPaymentData(response.data.paymentData, scheduleTime);
          dispatchUserAction({ type: "REFRESH_PROMOTION", pm: response.data.promotion });
          actionContext.setContainerItems(response.data.containerItems);
          actionContext.registerUISetup(
            response.data.icons,
            response.data.bgImg,
            response.data.landingImg,
            response.data.greetingMessage,
            response.data.tkSuccessMessage,
            response.data.colorTheme,
            response.data.supportMultiLan,
            response.data.hasPickUpTime,
            response.data.tkOrderAfter,
            response.data.startTime,
            response.data.endTime,
            response.data.currencySymbol,
            response.data.disSubCatAtSide,
            response.data.skipPaxControl,
            response.data.weekDays,
            response.data.allowTAafterWH,
            response.data.deliveryOrNot,
            response.data.deliveryCosts,
            response.data.minimumConsumption,
            response.data.isForCheckout,
            response.data.checkOutRec,
            response.data.isOnlinePayMinConsumption,
            response.data.onlinePayMinConsumptionVal,
            response.data.checkboxs,
            response.data.addItemDirect,
            response.data.unlimitedScroll,
            response.data.catPos,
            response.data.itemLayout,
            response.data.hasCategoryScreen,
            response.data.hasAdvocado,
            response.data.includeDineIn,
            response.data.tkDiMenuDiff,
            response.data.skipCustomerDetail,
            response.data.displayNetAmount,
            response.data.hasTakeAway,
            response.data.hasMember,
            response.data.haveToLogin,
            response.data.successMessage,
            response.data.allowRegister,
            response.data.advocadoRedeem,
            response.data.skipDIPickUpTime,
            response.data.skipTAPickUpTime,
            response.data.showLogo,
            response.data.hidePrice,
            response.data.isLanReverse,
            response.data.paymentSelectionMessage,
            response.data.mustDob,
            response.data.payAtCounter,
            response.data.hasVoucher,
            response.data.sameDayOrder,
            response.data.hideOptionalField,
            response.data.deliveryCalMethod,
            response.data.deliveryDisAmt, //if deliveryCalMethod is 1, has discount if more than certain
            response.data.deliverySpend,
            response.data.selectPUTimeFirst,
            response.data.showKitchenStatus,
            response.data.showPickUpInfo,
            response.data.pickUpPoint,
            response.data.advocadoStoreCredit,
            response.data.recentBought,
            response.data.memberRedeem,
            response.data.showCompanyName,
            response.data.additionalPickUpTime,
            response.data.advocadoSignUpLink,
            response.data.allowDineInTakeAway,
            response.data.takeAwayAllowAtCounter,
            response.data.hasFomoPay,
            response.data.upsellingTitle,
            response.data.checkStockBeforeCheckOut,
            response.data.mustEmail,
            response.data.smartRec,
            response.data.hasSlotControl,
            response.data.noOfAdvanceDays,
            response.data.hideLimitedTimeInfo,
            response.data.displayPaymentTerm,
            response.data.openingTime,
            response.data.closingTime,
            response.data.loginBottomText || '',
            response.data.topCatType,
            response.data.displayMenuDescription,
            response.data.displayDeliveryTerm,
            response.data.pickupTimeInterval
          );
          actionContext.registerInitFlow(response.data.hasInitFlow, response.data.initFlow);
          actionContext.registerOtherUrl(response.data.otherUrls);
          actionContext.registerAsiaPay(
            response.data.asiaPay,
            response.data.hasPayment,
            response.data.paymentPlatform,
            response.data.PaymentTakeawayOnly,
            response.data.isDemo,
            response.data.haveToPayOnline);
          actionContext.registerMenuTitle(
            response.data.menus
          );
          if (response.data.isTakeAway) {
            const currentTakeAwayInfo = latestUserState.current.takeAwayInfo || {};
            if (typeof currentTakeAwayInfo.deliveryType === 'undefined') {
              actionContext.setTkType(response.data.defaultType);
            } else {
              actionContext.setTkType(currentTakeAwayInfo.deliveryType);
            }
          } else {
            actionContext.setTkType(1);
          }
          setTheme(themes[response.data.colorTheme]);

        })
        .catch(function (response) {
          if (!active) return;
          // handle error
          if (response.errorCode === 0) {
            //error handler for multiple customer
          }
          if (response.errorCode === 1) {
            //error handler for check out
            localStorage.removeItem("bearerToken");
            localStorage.removeItem("userId");
            localStorage.removeItem("orderTime");
            localStorage.removeItem("pax");
            localStorage.removeItem("ads");
            localStorage.removeItem("tableLabel");
            localStorage.removeItem("company");
            localStorage.removeItem("tax");
            localStorage.removeItem("paymentData");
            localStorage.removeItem("otherUrls");
            localStorage.removeItem("hasPayment");
            localStorage.removeItem("PaymentTakeawayOnly");
            localStorage.removeItem("isTakeAway");
            localStorage.removeItem("isPreOrder");
            localStorage.removeItem("isMenuView");
            localStorage.removeItem("TITLE");
            localStorage.removeItem("paymentPlatform");
            localStorage.removeItem("asiaPay");
            localStorage.removeItem("theme");
            localStorage.removeItem("tkSuccessMessage");
            localStorage.removeItem("isDemo")
            localStorage.removeItem("supportMultiLan");
            localStorage.removeItem("hasPickUpTime");
            localStorage.removeItem("tkOrderAfter");
            localStorage.removeItem("startTime");
            localStorage.removeItem("endTime");
            localStorage.removeItem('currencySymbol');
            localStorage.removeItem('disSubCatAtSide');
            localStorage.removeItem('deliveryOrNot');
            localStorage.removeItem('deliveryCosts');
            localStorage.removeItem('minimumConsumption');
            localStorage.removeItem('isForCheckout');
            localStorage.removeItem('checkOutRec');
            localStorage.removeItem('checkboxs');
            localStorage.removeItem('isOnlinePayMinConsumption');
            localStorage.removeItem('onlinePayMinConsumptionVal');
            localStorage.removeItem('haveToPayOnline');
            localStorage.removeItem('addItemDirect');
            localStorage.removeItem('unlimitedScroll');
            localStorage.removeItem('hasCategoryScreen');
            localStorage.removeItem('hasAdvocado');
            localStorage.removeItem("includeDineIn");
            localStorage.removeItem("tkDiMenuDiff");
            localStorage.removeItem("skipCustomerDetail");
            localStorage.removeItem("displayNetAmount");
            localStorage.removeItem("hasTakeAway");
            localStorage.removeItem("hasMember");
            localStorage.removeItem("haveToLogin");
            localStorage.removeItem("allowRegister");
            localStorage.removeItem("advocadoRedeem")
            localStorage.removeItem("skipDIPickUpTime");
            localStorage.removeItem("skipTAPickUpTime");
            localStorage.removeItem("showLogo")
            localStorage.removeItem("hidePrice");
            localStorage.removeItem("isLanReverse");
            localStorage.removeItem("paymentSelectionMessage");
            localStorage.removeItem('mustDob');
            localStorage.removeItem('mustEmail');
            localStorage.removeItem('smartRec');
            localStorage.removeItem('hasSlotControl');
            localStorage.removeItem('pickupTimeInterval');
            localStorage.removeItem('payAtCounter');
            localStorage.removeItem('hasVoucher');
            localStorage.removeItem('sameDayOrder');
            localStorage.removeItem('hideOptionalField');
            localStorage.removeItem('hideLimitedTimeInfo');
            localStorage.removeItem('displayPaymentTerm');
            localStorage.removeItem('displayDeliveryTerm');
            localStorage.removeItem('displayMenuDescription');
            localStorage.removeItem('openingTime');
            localStorage.removeItem('closingTime');
            localStorage.removeItem('loginBottomText');
            localStorage.removeItem('deliveryCalMethod');
            localStorage.removeItem('deliveryDisAmt');
            localStorage.removeItem('deliveryPrice');
            localStorage.removeItem('showKitchenStatus');
            localStorage.removeItem('showPickUpInfo');
            localStorage.removeItem('pickUpPoint');
            localStorage.removeItem('advocadoStoreCredit');
            localStorage.removeItem('recentBought');
            localStorage.removeItem('additionalPickUpTime');
            localStorage.removeItem('allowDineInTakeAway');
            localStorage.removeItem('takeAwayAllowAtCounter');
            localStorage.removeItem('hasFomoPay');
            localStorage.removeItem('upsellingTitle');
            localStorage.removeItem('checkStockBeforeCheckOut');
            localStorage.removeItem('hasInitFlow');
            localStorage.removeItem('initFlow');
          }
          if (response.errorCode === 2) {
            //checkout, but try to access within 1 hour
          }
        })
        .then(function () {
          // always executed
        });
    }
    return () => { active = false; };
  }, [actionContext, userState.orderTime, userState.token, userState.userId, userState.takeAwayInfo && userState.takeAwayInfo.scheduleTime]);

  return (
    <React.Fragment>
      <LanguageContext.Provider value={languageContext}>
        <ThemeContext.Provider value={themeContext}>
          <ActionContext.Provider value={actionContext}>
            <UserContext.Provider value={userState}>
              <Router>
                <CustomerReset path="/passwordreset" />
                {userState.token === "" ? (
                  <Checkin path="/checkin/:token" />
                ) : (
                  <React.Fragment>
                    <Checkin path="/checkin/:token/:reserveId" />
                    <Checkin path="/checkin/:token" />
                    <CategoryWithPromotion path="/category" />
                    <MenuWithPromotion path="/menu" />
                    <MenuWithPromotion path="/menu/menu/:category" />
                    <MenuWithPromotion path="/menu/item/:codeId" />
                    <CheckoutModalRoute path="/checkout" />
                    <PaymentSummary path="/payment" />
                    <Success path="/payment/success" />
                    <Fail path="/payment/fail" />
                    <Cancel path="/payment/cancel" />
                    <OrderFail path="/order/fail" />
                    <PaymentLoading path="/payment/check" />
                    <CustomerLogin path="/member/login/:token" />
                    <CustomerDetail path="/member/info" />
                    <InitFlow path="/initflow" />

                  </React.Fragment>
                )}
              </Router>
            </UserContext.Provider>
          </ActionContext.Provider>
        </ThemeContext.Provider>
      </LanguageContext.Provider>
    </React.Fragment>
  );
}

export default App;
